import useSWR from "swr";
import axios from 'axios';
import { config } from "../config";

const getFetcher = function() {
  return async (url: string) => {
    const response = await axios.get(url);
    return response.data;
  }
}

export default function useConfig() {
  const fetcher = getFetcher();

  const configUrl = `${config.apiBasePath}config`;

  const swrKey = configUrl;

  // Prevent server-side error with conditionals
  const {data, error, isLoading} = useSWR(swrKey, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  return {
    authClientId: data?.authClientId,
    authTenantId: data?.authTenantId,
    isLoading,
    isError: error,
  };
}
